import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "vz_detail_drawer",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "vz_detail_drawer",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'100%', 'sm': '100%', 'md': '100%', 'lg': '100%', 'xl': '100%'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#vz_detail_drawer_toggle",
  "data-kt-drawer-close": "#vz_detail_drawer_close"
}
const _hoisted_2 = { class: "card shadow-none rounded-0 w-100 bg-light" }
const _hoisted_3 = { class: "card m-5 bg-transparent" }
const _hoisted_4 = { class: "d-flex align-items-end justify-content-end bg-white px-4 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "card-header border-bottom-0 bg-white",
  id: "vz_detail_drawer__header"
}
const _hoisted_8 = { class: "card-title fw-bolder text-gray-700" }
const _hoisted_9 = { class: "symbol symbol-circle symbol-40px me-4" }
const _hoisted_10 = { class: "symbol-label border border-primary border-dashed" }
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-body mx-5 p-0",
  id: "vz_detail_drawer__body"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_explore_scroll",
    class: "scroll-y me-n5 pe-3",
    "data-kt-scroll": "true",
    "data-kt-scroll-height": "auto",
    "data-kt-scroll-wrappers": "#vz_detail_drawer__body",
    "data-kt-scroll-dependencies": "#vz_detail_drawer__header",
    "data-kt-scroll-offset": "5px"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-0" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZTabs = _resolveComponent("VZTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-icon btn-active-color-primary h-40px w-40px me-n2",
            id: "vz_detail_drawer__close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideDrawer && _ctx.hideDrawer(...args)))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.icon)
                }, null, 2)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.$slots.actions)
              ? _renderSlot(_ctx.$slots, "actions", { key: 0 })
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_VZTabs, { tabs: _ctx.tabs }, null, 8, ["tabs"])
        ])
      ]),
      _hoisted_12
    ])
  ]))
}